/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://mbu3uylbtnhltjq73fajullkja.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-nrzgdciaxresdajdd2b6ik4c7e",
    "aws_cognito_identity_pool_id": "us-east-1:3a1da802-2d3b-482b-9724-cccd4b8de59e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_cfdoDp7Tm",
    "aws_user_pools_web_client_id": "7f02jb9mmpepuft52ue16ugqur",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "subscribers-staging",
            "region": "us-east-1"
        }
    ],
    "geo": {
        "amazon_location_service": {
            "region": "us-east-1",
            "maps": {
                "items": {
                    "hdieawya-staging": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "hdieawya-staging"
            }
        }
    }
};


export default awsmobile;
